import {createFileRoute} from '@tanstack/react-router';

import {SiteDetailPage} from '@/modules/sites/pages/SiteDetailPage';

/**
 * URL state for the site detail. `from` records where the user opened the site
 * from, so the breadcrumb roots at Projects (when opened from a project) or
 * Sites (the default). Optional so bare links still work.
 */
export interface SiteDetailSearch {
  from?: 'project';
}

const validateSiteDetailSearch = (search: Record<string, unknown>): SiteDetailSearch => ({
  from: search.from === 'project' ? 'project' : undefined,
});

export const Route = createFileRoute('/_authenticated/sites/$siteId')({
  validateSearch: validateSiteDetailSearch,
  component: SiteDetailPage,
});
